import { render, staticRenderFns } from "./marketCodeProductDetail.vue?vue&type=template&id=a74d8050&"
import script from "./marketCodeProductDetail.vue?vue&type=script&lang=js&"
export * from "./marketCodeProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports